import type { KeyBinding } from '@codemirror/view';

/**
 * Ctrl+S / Cmd+S in the code editor. Edits already reach the preview on their own (a 450 ms
 * debounce in `EditorPanel`), so the key only has to sync now and must never fall through:
 * with no binding, the browser opened its "Save page" dialog, and a key sent without its
 * modifier typed a literal "s" into the file.
 */
export function editorSaveKeyBinding(onSave: () => void): KeyBinding {
  return {
    key: 'Mod-s',
    preventDefault: true,
    run: () => {
      onSave();
      return true;
    },
  };
}

/** The same key outside the editor (file tree, tabs), where CodeMirror never sees it. */
export function isSaveShortcut(e: Pick<KeyboardEvent, 'key' | 'ctrlKey' | 'metaKey' | 'altKey'>): boolean {
  return (e.ctrlKey || e.metaKey) && !e.altKey && (e.key === 's' || e.key === 'S');
}
